import { equalizeHeights } from '/source/_patterns/01-components/equalizer/equalizer';

function initializeSlickSlider(slider) {
    slider.slick({
        dots: false,
        infinite: false,
        speed: 0,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 0,
        arrows: true,
        mobileFirst: false,
        responsive: [
            {
                breakpoint: 1160,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 481,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
}

// Function to destroy Slick slider
function destroySlickSlider(slider) {
    slider.slick('unslick');
}

function initEventHandlers() {
    // Set the default tab to be active
    document.getElementById('tab_0').style.display = 'block';
    let defaultButton = document.querySelector('button[data-tab="tab_0"]');
    defaultButton.classList.add('active');

    const tabButtons = document.querySelectorAll('.tab-link');
    tabButtons.forEach((button) => {
        button.addEventListener('click', () => {
            // Hide all tab content
            document.querySelectorAll('.tab-content').forEach((content) => {
                content.style.display = 'none';
            });

            // Remove the 'active' class from all tab buttons
            tabButtons.forEach((tabButton) => {
                tabButton.classList.remove('active');
            });

            // Display the clicked tab content
            const tabName = button.getAttribute('data-tab');
            const tabContent = document.getElementById(tabName);
            tabContent.style.display = 'block';

            // Mark the clicked tab button as active
            button.classList.add('active');

            // Find the Slick slider within the tab content
            const slider = $(tabContent).find('.isa-custom-carousel');

            // Destroy any existing Slick slider and initialize a new one
            if(slider.length) {
                destroySlickSlider(slider);
                initializeSlickSlider(slider);
            }

            // Adjust carousel content height
            setTimeout(function () {
                setCarouselContentHeight();
            }, 300);
        });
    });
}
function setCarouselContentHeight() {
    var featuredStoryContent = $(
        '.featured-category-carousel__product-description'
    );
    equalizeHeights(featuredStoryContent);
}

function checkForFeaturedCategoryCarouselFilters() {
    return $('.featured-category-carousel').length > 0 && $('#tab_0').length > 0;
}

$(function () {
    if(checkForFeaturedCategoryCarouselFilters()) {
        initEventHandlers();

        setTimeout(function () {
            setCarouselContentHeight();
        }, 300);
        $(window).resize(function () {
            setTimeout(function () {
                setCarouselContentHeight();
            }, 300);
        });
    }
});
